import ContactGroup from "../contact-groups/ContactGroup";
import NotificationTemplate from "../notification-templates/NotificationTemplate";
import NotificationRuleCondition, { DefaultNotificationRuleCondition } from "./NotificationRuleCondition";

export default interface NotificationRule {
    notificationRuleId?: number;
    title: string;
    tenantId?: number;
    conditions: NotificationRuleCondition[];
    notificationTemplateId?: number | null;
    notificationTemplateName?: string | null;
    notificationTemplate?: NotificationTemplate | null;
    userIds?: number[];
    contactGroupIds?: string[];
	contactGroups?: ContactGroup[];
    emailAddresses?: string[];
}

export const DefaultNotificationRule: NotificationRule = {
    notificationRuleId: null,
    tenantId: null,
    title: "",
    conditions: [DefaultNotificationRuleCondition],
    notificationTemplateId: null,
    notificationTemplateName: null,
    userIds: [],
    contactGroupIds: [],
	contactGroups: [],
    emailAddresses: [],
}
